import { render, staticRenderFns } from "./DataAccessSubscriptionCheckPage.vue?vue&type=template&id=0fa2d407&scoped=true&"
import script from "./DataAccessSubscriptionCheckPage.vue?vue&type=script&lang=ts&"
export * from "./DataAccessSubscriptionCheckPage.vue?vue&type=script&lang=ts&"
import style0 from "./DataAccessSubscriptionCheckPage.vue?vue&type=style&index=0&id=0fa2d407&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa2d407",
  null
  
)

export default component.exports